(() => {
 const init=()=>document.querySelectorAll('.drx-gateway').forEach(stage=>{
  if(stage.dataset.eyesReady)return;stage.dataset.eyesReady='true';
  const eyes=[...stage.querySelectorAll('[data-crown-gaze]')];
  const reduce=matchMedia('(prefers-reduced-motion: reduce)');
  let last=null,idle,surpriseUntil=0,winkUntil=0;
  const mood=value=>eyes.forEach(eye=>eye.dataset.mood=value);
  const reset=()=>{clearTimeout(idle);last=null;surpriseUntil=0;winkUntil=0;mood('neutral');eyes.forEach(eye=>{eye.style.setProperty('--gaze-x','0px');eye.style.setProperty('--gaze-y','0px')})};
  stage.addEventListener('pointermove',event=>{
   if(reduce.matches||event.pointerType==='touch')return;
   const r=stage.getBoundingClientRect();
   const speed=last?Math.hypot(event.clientX-last.x,event.clientY-last.y)/Math.max(1,event.timeStamp-last.t):0;
   last={x:event.clientX,y:event.clientY,t:event.timeStamp};
   if(speed>2.4)surpriseUntil=event.timeStamp+650;
   const x=Math.max(-9,Math.min(9,(event.clientX-r.left-r.width/2)/r.width*24));
   const y=Math.max(-7,Math.min(7,(event.clientY-r.top-180)/r.height*18));
   eyes.forEach(eye=>{eye.style.setProperty('--gaze-x',`${eye.closest('.drx-gateway__world--supply')?-x:x}px`);eye.style.setProperty('--gaze-y',`${y}px`)});
   if(event.timeStamp>=winkUntil){
    if(event.target.closest('.drx-command'))mood('excited');
    else if(event.timeStamp<surpriseUntil)mood('surprised');
    else if(Math.abs(event.clientX-r.left-r.width/2)<r.width*.09){eyes.forEach((eye,i)=>eye.dataset.mood=i===0?'curious':'skeptical')}
    else mood(event.clientY<r.top+280?'curious':event.target.closest('.drx-gateway__world--supply')?'focused':'happy');
   }
   clearTimeout(idle);idle=setTimeout(()=>mood('chill'),2000);
  },{passive:true});
  stage.addEventListener('pointerleave',reset);
  stage.addEventListener('focusin',()=>{if(!reduce.matches)mood('happy')});
  stage.addEventListener('focusout',reset);
  stage.addEventListener('pointerover',event=>{
   if(reduce.matches||!event.target.closest('.drx-command')||event.relatedTarget?.closest?.('.drx-command')===event.target.closest('.drx-command'))return;
   winkUntil=event.timeStamp+650;
   eyes.forEach((eye,i)=>eye.dataset.mood=i===0?'wink':'happy');
  });
  stage.addEventListener('pointerdown',()=>{if(!reduce.matches)mood('excited')},{passive:true});
  reduce.addEventListener('change',reset);
  document.addEventListener('visibilitychange',()=>{eyes.forEach(eye=>eye.dataset.paused=String(document.hidden));if(document.hidden)reset()});
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();
